export default __webpack_public_path__ + "static/B0296-5e5c4d1faa02a008102efc4d02cb0480.png";